import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetDept/Main";
import Form from "./TbSetDept/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDatatype } from "../../../model/InitialData/InitialDataCreditor";
import Navbar from "../../components/Modal/Navbar";

const TbSetDept = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  //   const [dataAPtype, setDataAPtype] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDatatype());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_AP ทั้งหมด
      const masterList = await getData("Tb_Set_Dept", "1=1");
      //   const dataAPtype = await getData("Tb_Set_APType", "1=1");
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
      //   if (dataAPtype && dataAPtype.length > 0) {
      //     setDataAPtype(dataAPtype);
      //   }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");

    setFormData({
      Dept_Id: 0,
      Dept_Name: "",
      Dept_Status: "Y",
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลแผนก"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลแผนก"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  //   dataAPtype={dataAPtype}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetDept;
